// export const baseURL = "https://thzretail.com/ContendZONE/";
export const baseURL = "https://devapi.contendzone.com/ContendZONE/";
// https://devapi.contendzone.com/ContendZONE/api/school/getAllStates/233
// Login
export const login = "/api/auth/login";
// School controller
export const getAllSchoolType = "api/school/get-all-school-type";
export const getAllSchool = "api/school/get-all-schools-dropdown";
export const getAllSports = "api/school/get-all-sport";
export const getAllCountries = "api/school/loadAllCountries";
export const addSchoolAdminRegistration = "api/school/add-school-admin";
export const statesListBycountryId = "api/school/getAllStates/";
export const checkEmailValidatiion = "api/auth/checkEmailInUse?email=";

